import React from 'react';
import {useParams} from 'react-router-dom';
import ConfigText from '../components/documentation/ConfigText';

const DocumentationPage = () => {
  const {eid} = useParams();
  return <div className="h-100"><ConfigText eid={eid}/></div>;
};
export default DocumentationPage;
